import React from "react";
import { Navbar } from "../components/home/Navbar";
import { Hero } from "../components/home/Hero";
import { TrustStrip } from "../components/home/TrustStrip";
import { Commitments } from "../components/home/Commitments";
import { Solutions } from "../components/home/Solutions";
import { ClientSpace } from "../components/home/ClientSpace";
import { Method } from "../components/home/Method";
import { Team } from "../components/home/Team";
import { ContactCta } from "../components/home/ContactCta";
import { Footer } from "../components/home/Footer";
export function Home() {
  return <div className="min-h-screen w-full bg-canvas text-ink" data-id="element-207" data-mp="29flsc42czsyy">
      <Navbar data-id="element-208" data-mp="29i80a4t5wahp" />
      <main data-id="element-209" data-mp="2dhqi2rpos5gb">
        <Hero data-id="element-210" data-mp="2dhgu19o7c8d9" />
        <TrustStrip data-id="element-211" data-mp="2dhyuyjlt7ari" />
        <Commitments data-id="element-212" data-mp="2dii2r7hqwirt" />
        <Solutions data-id="element-213" data-mp="2dfm4fi1zjs2u" />
        <ClientSpace data-id="element-214" data-mp="3kvag2xnfsw0t" />
        <Method data-id="element-215" data-mp="3kvtmpi7mzxzj" />
        <Team data-id="element-216" data-mp="3ku8sxut5cj2q" />
        <ContactCta data-id="element-217" data-mp="3kuqvf96ejtj3" />
      </main>
      <Footer data-id="element-218" data-mp="3kxmx98ldf2ct" />
    </div>;
}